import type { ReactNode } from 'react';

export type SpriteIconName =
    | 'account'
    | 'address'
    | 'ai'
    | 'app-store'
    | 'arrow'
    | 'bag'
    | 'briefcase'
    | 'filters'
    | 'log-in'
    | 'search'
    | 'chevron'
    | 'clear'
    | 'clear-filled';

const icons: Record<
    SpriteIconName,
    {
        viewBox: string;
        content: ReactNode;
    }
> = {
    account: {
        viewBox: '0 0 32 32',
        content: (
            <path
                fillRule="evenodd"
                d="M8 18.73c0-.68.55-1.23 1.23-1.23h13.54c.68 0 1.23.55 1.23 1.23v7.77h-2v-7H10v7H8v-7.77Zm8-5.23a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
                clipRule="evenodd"
            />
        ),
    },
    address: {
        viewBox: '0 0 32 32',
        content: (
            <>
                <path
                    fillRule="evenodd"
                    d="M22 6H11a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1ZM11 4a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H11Z"
                    clipRule="evenodd"
                />
                <path
                    fillRule="evenodd"
                    d="M12 9a1 1 0 0 1-1 1H7a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1Zm0 7a1 1 0 0 1-1 1H7a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1Zm0 7a1 1 0 0 1-1 1H7a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1Z"
                    clipRule="evenodd"
                />
            </>
        ),
    },
    ai: {
        viewBox: '0 0 24 24',
        content: (
            <>
                <path
                    d="M13.313 11.687c.948.947 2.15 1.593 3.768 2.181-1.617.588-2.82 1.234-3.768 2.181-.947.948-1.593 2.15-2.181 3.768-.588-1.617-1.234-2.82-2.181-3.768-.948-.947-2.15-1.593-3.768-2.181 1.617-.588 2.82-1.234 3.768-2.181.947-.948 1.593-2.15 2.181-3.768.588 1.617 1.234 2.82 2.181 3.768Z"
                    stroke="#000"
                    strokeWidth="1.25"
                />
                <path
                    d="M17.434 10.027c-.257-.607-.553-1.097-.958-1.502-.405-.405-.895-.702-1.502-.958.606-.257 1.096-.554 1.5-.959.406-.405.703-.894.96-1.502.256.607.553 1.097.958 1.502.405.405.895.702 1.502.958-.607.257-1.097.554-1.502.958-.405.405-.701.895-.958 1.503Z"
                    stroke="#000"
                />
            </>
        ),
    },
    'app-store': {
        viewBox: '0 0 18.5 22.3',
        content: (
            <path d="M15.2 11.8c0-2.8 2.3-4.1 2.4-4.2-1.3-1.9-3.3-2.1-4-2.2-1.7-.2-3.3 1-4.2 1s-2.2-1-3.6-1C4 5.4 2.3 6.5 1.3 8.1c-1.9 3.3-.5 8.3 1.4 11 .9 1.3 2 2.8 3.4 2.8S8 21 9.7 21s2.1.9 3.6.9 2.4-1.3 3.3-2.7c1.1-1.5 1.5-3 1.5-3.1 0 0-2.9-1.1-2.9-4.4Zm-2.7-8.1c.7-.9 1.3-2.2 1.1-3.5-1.1 0-2.4.7-3.2 1.7-.7.8-1.3 2.1-1.1 3.4 1.2 0 2.5-.6 3.2-1.5Z" />
        ),
    },
    arrow: {
        viewBox: '0 0 32 32',
        content: (
            <>
                <path d="M19.3 22.7a1 1 0 0 1 0-1.4l5.29-5.3-5.3-5.3a1 1 0 0 1 1.42-1.4l5.93 5.92a1.1 1.1 0 0 1 0 1.56L20.7 22.7a1 1 0 0 1-1.42 0Z" />
                <path d="M6 15h19v2H6a1 1 0 1 1 0-2Z" />
            </>
        ),
    },
    bag: {
        viewBox: '0 0 32 32',
        content: (
            <>
                <path d="M12 26a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm12 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
                <path
                    fillRule="evenodd"
                    d="M9 7h16.67c.86 0 1.45.86 1.15 1.66L23.69 17H10.5v-2h11.8l2.26-6H9V7Z"
                    clipRule="evenodd"
                />
                <path
                    fillRule="evenodd"
                    d="M4 5h5.32l2.22 11.1L9.98 20H25v2H8.84c-.86 0-1.47-.87-1.14-1.69l1.76-4.4L7.68 7H4V5Z"
                    clipRule="evenodd"
                />
            </>
        ),
    },
    briefcase: {
        viewBox: '0 0 32 32',
        content: (
            <>
                <path
                    fillRule="evenodd"
                    d="M25 12H7a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1ZM7 10a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V13a3 3 0 0 0-3-3H7Z"
                    clipRule="evenodd"
                />
                <path
                    fillRule="evenodd"
                    d="M12 11a1 1 0 0 1-1-1V7a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1Zm8 0a1 1 0 0 1-1-1V7a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1Z"
                    clipRule="evenodd"
                />
                <path
                    fillRule="evenodd"
                    d="M11 7a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1Z"
                    clipRule="evenodd"
                />
            </>
        ),
    },
    filters: {
        viewBox: '0 0 32 32',
        content: (
            <path d="M19.9 5.9v6.2h2.2v-2h5V7.9h-5v-2h-2.2Zm-1.8 2H4.9v2.2h13.2V7.9Zm-8.2 5v2h-5v2.2h5v2h2.2v-6.2H9.9Zm17.2 2H13.9v2.2h13.2v-2.2Zm-12.07 5v6.2h2.19v-2h9.87v-2.2h-9.87v-2h-2.19Zm-2.4 2H4.95v2.17h7.68V21.9Z" />
        ),
    },
    'log-in': {
        viewBox: '0 0 32 32',
        content: (
            <>
                <path d="M14 6a1 1 0 0 1 1-1h7a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4h-7a1 1 0 1 1 0-2h7a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-7a1 1 0 0 1-1-1Z" />
                <path d="M14.3 20.7a1 1 0 0 1 0-1.4l3.29-3.3-3.3-3.3a1 1 0 0 1 1.42-1.4l3.93 3.92a1.1 1.1 0 0 1 0 1.56L15.7 20.7a1 1 0 0 1-1.42 0Z" />
                <path d="M6 15h12v2H6a1 1 0 1 1 0-2Z" />
            </>
        ),
    },
    search: {
        viewBox: '0 0 32 32',
        content: (
            <>
                <path d="M19 17.59 26.41 25 25 26.41 17.59 19 19 17.59Z" />
                <path
                    fillRule="evenodd"
                    d="M14 20a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm0 2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
                    clipRule="evenodd"
                />
            </>
        ),
    },
    chevron: {
        viewBox: '0 0 32 32',
        content: <path d="M9.91 24.96 19.37 16 9.9 7.04l1.5-1.58L22.54 16 11.41 26.54l-1.5-1.58Z" />,
    },
    clear: {
        viewBox: '0 0 32 32',
        content: (
            <>
                <path
                    fillRule="evenodd"
                    d="m20.87 12.23-8.64 8.64-1.42-1.41 8.65-8.65 1.41 1.42Z"
                    clipRule="evenodd"
                />
                <path
                    fillRule="evenodd"
                    d="m19.77 20.87-8.64-8.64 1.41-1.42 8.65 8.65-1.42 1.41Z"
                    clipRule="evenodd"
                />
                <path
                    fillRule="evenodd"
                    d="M16 25a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0 2a11 11 0 1 0 0-22 11 11 0 0 0 0 22Z"
                    clipRule="evenodd"
                />
            </>
        ),
    },
    'clear-filled': {
        viewBox: '0 0 32 32',
        content: (
            <path
                fillRule="evenodd"
                d="M23.78 23.78A11 11 0 1 0 8.22 8.22a11 11 0 0 0 15.56 15.56ZM16 14.77l-3.46-3.46-1.41 1.42 3.46 3.46-3.78 3.77 1.42 1.41L16 17.6l3.77 3.77 1.42-1.41-3.78-3.77 3.46-3.46-1.41-1.42L16 14.77Z"
                clipRule="evenodd"
            />
        ),
    },
};

interface SpriteIconProps {
    name: SpriteIconName;
    className?: string;
}

export function SpriteIcon({ name, className }: SpriteIconProps) {
    const icon = icons[name];

    return (
        <svg className={className} aria-hidden="true" viewBox={icon.viewBox}>
            {icon.content}
        </svg>
    );
}
